module.exports = __webpack_public_path__ + "static/valueTransparency-645e06b1f8f57c7a9beb94eeb9bd33b9.png";